<template>
  <div>
        <b-form-group v-if="registrySettings.length>0" label-align="left" :label="$t('Allow edit profile')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox size="lg" @change="ChangeSettingEditProfile" switch class="mt-2" v-model="registrySettings[0].raw_values[0].value" unchecked-value="0" value="1"/>
        </b-form-group>

    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
        v-if="editProfile"
        :items="editProfile"
        :fields="fields"
        @ClickOnDeleteButton="ClickOnDeleteButton"
        @ClickOnEditButton="editItem"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"
        isDelete="true"
        isEdit="true"/>
    <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    <editModal :editItem="selected"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  data () {
    return {
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'group_id',
          label: this.$i18n.t('Group'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('All') + '(0)'
            }
            for (let el of this.groups) {
              if (val === el.group_id) {
                return el.group_name + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selected: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  components: {
    editModal
  },
  methods: {
    ChangeSettingEditProfile (checked) {
      let tmp = JSON.parse(JSON.stringify(this.registrySettings[0]))
      tmp.object_id = 0
      tmp.raw_values[0].value = String(checked)
      this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', tmp).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
        }
      })
      setTimeout(this.$store.dispatch, 500, 'Settings/GET_REGISTRY_SETTINGS', {group_id: 15, object_id: 0})
    },

    ClickOnDeleteButton (item) {
      let msg = this.$i18n.t('Are you sure you want to delete one of') + ' "' + this.$i18n.t('Edit profile') + '"?'
      this.$root.$emit('showConfirmation', 'Confirmation', msg, this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_EDIT_PROFILE', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_EDIT_PROFILE')
          this.$root.$emit('makeToasts')
        }
      })
    },
    editItem (item) {
      this.selected = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditEditProfileSetting', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    showAdd () {
      this.selected = {
        id: 0,
        group_id: 0,
        is_enabled: 0,
        available_fields: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditEditProfileSetting', '#btnShow')
    }
  },
  computed: {
    editProfile () {
      return this.$store.getters['Settings/EDIT_PROFILE']
    },
    groups () {
      return this.$store.getters['Users/GROUPS']
    },
    registrySettings () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS'].filter(el => {
        return el.name === 'customer_portal_edit_profile'
      })
    }

  },
  mounted () {
    this.$store.dispatch('Settings/GET_EDIT_PROFILE')
    this.$store.dispatch('Users/GET_GROUPS')
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 15, object_id: 0})
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/editProfile/main.vue